<!-- eslint-disable vue/no-deprecated-v-bind-sync -->
<template>
  <v-row class="mb-2">
    <v-col cols="7" class="mx-n4 mt-1">
      <v-card-title>Appliquer un filtre</v-card-title>
    </v-col>

    <v-col cols="10" class="mt-n8 ">
      <v-autocomplete
        v-model="facetNewValue.facet"
        :items="facetsList"
        item-text="label"
        item-value="value"
        item-color="info"
        menu-props="light"
        label="Facette"
        color="blue"
        clearable
        :rules="[(v) => !!v || 'Required']"
        @change="changeFacet"
      />
    </v-col>
    <v-col cols="10">
      <v-select
        v-model="facetNewValue.operator"
        label="Logical Operator"
        :items="logicalOperatorsItems"
        item-color="info"
        item-text="label"
        menu-props="light"
        color="blue"
        :disabled="!facetNewValue.facet"
        @change="updateOperatorValue($event)"
      />
    </v-col>

    <ApplyFilterBetween v-if="showBetweenForm" :filters-values="action" />
    <v-col v-else cols="10">
      <FacetValuesSelection
        v-model="facetNewValue.values"
        :facet="facetNewValue.facet"
        :type="typeOfInput"
        :allow-copy="!disableCopyPaste && compatibleCopyPaste"
        :disabled="!facetNewValue.facet"
        :search-by-query="searchByQuery"
        :multiple="multipleEnabled"
        :free-field="freeField"
        :rules="multipleEnabled ? [(v) => (v && !!v.length > 0) || 'Required'] : [(v) => !!v || 'Required']"
      />
    </v-col>
  </v-row>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { useStore } from 'vue2-helpers/vuex';
import ApplyFilterBetween from './common/ApplyFilterBetween.vue';
import FacetValuesSelection from './common/FacetValuesSelection.vue';

const store = useStore();

const { useFacetSettings } = require('@/utils/merch');

const props = defineProps({ action: { type: Object, required: true } });

const facetNewValue = ref(props.action);

const { disableCopyPaste, searchByQuery, facetsList, facetSettings } = useFacetSettings(facetNewValue, store.getters.ruleFacets);

const changeFacet = val => {
  facetNewValue.value.values = [];
  facetNewValue.value.operator = '=';
};

const freeField = computed(() => facetSettings.value && facetSettings.value.config.freeField);

const typeOfInput = computed(() => (['<', '<=', '>=', '>'].includes(facetNewValue.value.operator) ? 'number' : 'text'));
const compatibleCopyPaste = computed(() => typeOfInput.value !== 'number');
const multipleEnabled = computed(() => ['=', '!='].includes(facetNewValue.value.operator));
const showBetweenForm = computed(() => facetNewValue.value.operator === 'between');

const logicalOperatorsItems = computed(() => {
  let operators = ['=', '!='];

  if (facetSettings.value && facetSettings.value.config.allLogicOperators) {
    operators = operators.concat(['<', '<=', '>=', '>', { value: 'between', label: 'compris entre' }]);
  }

  return operators;
});

// const toObject = input => {
//   if (multipleEnabled.value && input.length) {
//     const values = [];
//     input.map(value => {
//       if (typeof value !== 'object' && isNaN(value)) {
//         return;
//       }

//       if (typeof value === 'object') {
//         values.push(value);
//         return;
//       }

//       values.push({ value: value, label: value });
//     });

//     facetNewValue.value.values = values;
//   } else {
//     facetNewValue.value.values = typeof input === 'object' ? input : { value: input, label: input };
//   }
// };

const updateOperatorValue = operator => {
  delete facetNewValue.value.valueFROM;
  delete facetNewValue.value.valueTO;

  if (['=', '!='].includes(operator)) {
    facetNewValue.value.values = [];
  } else {
    facetNewValue.value.values = null;
  }
};

</script>
